import React from 'react'
import {Grid} from '@material-ui/core'
import imgsrc from '../../assets/svg/No_result_found.svg'

const NoResultFound = props => {
    let msg = props.message ? props.message : 'No Data Found'
    let imagePath = props.imageName ? props.imageName : 'No_result_found'
    // let imagePath = props.imageSrcUrl ? props.imageSrcUrl : NoResultFound
    // let noResultText = props.noResultText
    //     ? props.noResultText
    //     : i18next.t('noResultFoundContainer.noResultText')
    return (
        <Grid container className="no--result_wrapper">
            <Grid item className="no--result_grid">
                <Grid item className="no--result_content">
                    <h2 className="no--result_heading">{msg}</h2>
                    {/* <Typography variant="subheading" className="no--result_message">
                        {props.message}
                    </Typography> */}
                </Grid>
                <Grid item className="no--result_img-grid">
                    <img
                        src={require(`../../assets/svg/${imagePath}.svg`)}
                        alt="No Result Found"
                        className="page-not-found_img"
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default NoResultFound
